import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Chip,
  Tooltip,
} from "@mui/material";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import CommonDatePicker from "../../../../Components/Common Components/CommonDatePicker";
import { DateTime } from "luxon";
import ToastMsg from "../../../../Components/ToastMsg/ToastMsg";
import { withTranslation } from "react-i18next";
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from "../../../../Components/Common Components/CommonComponents";
import { ImagePaths } from "../../../../Utility/ImagePaths";
import { AmountsCard } from "../../../../Components/CommonCards/CommonCards";
import { localGetItem } from "../../../../Utility/Services/CacheProviderService";
import { ContentInTooltip } from "../../../../Components/CommonFunctions/CommonFunctions";

const MessageReport = (props) => {
  const { t } = props;
  const [reportData, setReportData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [isErrorMsgText, setIsErrorMsgText] = useState("");
  const userData = localGetItem("userData");
  const facilityTimezone = userData?.facility_timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [fromDate, setFromDate] = useState(
    DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")
  );
  const [toDate, setToDate] = useState(
    DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")
  );
  const [dateIndex, setDateIndex] = useState(1);
  const [patientName, setPatientName] = useState("");
  const [uhid, setUhid] = useState("");
  const [mobile, setMobile] = useState("");
  const [messageType, setMessageType] = useState("all");
  const [smsType, setSmsType] = useState("all");
  const [status, setStatus] = useState('all')
  const [totalMessages, setTotalMessages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [FilterOpen, setFilterOpen] = useState(false);
  const [FilteredFromDate, setFilteredFromDate] = useState(
    DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")
  );
  const [FilteredToDate, setFilteredToDate] = useState(
    DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd")
  );

  const smsTypes = [
    { value: "all", label: "All Message Types" },
    // SMS Types
    { value: "prescription_sms", label: "Patient Prescription Report SMS" },
    { value: "visit_report_sms", label: "Doctor Visit Report SMS" },
    { value: "op_bill_sms", label: "OP Billing SMS" },
    { value: "ip_bill_sms", label: "IP Billing SMS" },
    { value: "lab_bill_sms", label: "Lab Billing SMS" },
    { value: "pharmacy_bill_sms", label: "Pharmacy Billing SMS" },
    { value: "radiology_bill_sms", label: "Radiology Billing SMS" },
    { value: "appointment_confirmation_sms", label: "Appointment Confirmation SMS" },
    // { value: "appointment_changed_sms", label: "Appointment Changed SMS" },
    { value: "appointment_canceled_sms", label: "Appointment Cancelled SMS" },
    { value: "appointment_completed_sms", label: "Appointment Completed SMS" },
    { value: "appointment_rescheduled_sms", label: "Appointment Rescheduled SMS" },
    { value: "appointment_transferred_sms", label: "Appointment Transferred SMS" },
    { value: "appointment_token_sms", label: "Appointment Token SMS" },
    { value: "future_appointment_sms_reminder", label: "Future SMS Appointment Reminder" },
    { value: "followup_sms_reminder", label: "Followup SMS Reminder" },
    { value: "doctor_emergency_sms", label: "Doctor Emergency SMS" },
    { value: "dr_unavailable", label: "Dr Unavailable"},
    { value: "rt_outstanding_reminder_sms", label: "Radiotherapy Outstanding Reminder SMS"},
    { value: "rt_outstanding_followup_reminder_sms", label: "Rt Outstanding Follow-up Reminder SMS"},

    // WhatsApp Types
    { value: "lab_report", label: "Lab Report WhatsApp" },
    { value: "doctor_visit_report", label: "Doctor Visit Report WhatsApp" },
    { value: "op_invoice", label: "OP Invoice WhatsApp" },
    { value: "ip_invoice", label: "IP Invoice WhatsApp" },
    { value: "lab_invoice", label: "Lab Invoice WhatsApp" },
    { value: "pharmacy_invoice", label: "Pharmacy Invoice WhatsApp" },
    { value: "radiology_invoice", label: "Radiology Invoice WhatsApp" },
    { value: "appointment_modification", label: "Appointment Modification WhatsApp" },
    { value: "appointment_cancellation", label: "Appointment Cancellation WhatsApp" },
    { value: "appointment_rescheduled", label: "Appointment Rescheduled WhatsApp" },
    { value: "appointment_transferred", label: "Appointment Transferred WhatsApp" },
    { value: "future_appointment_reminder", label: "Future Appointment Reminder WhatsApp" },
    { value: "appointment_followup_reminder", label: "Appointment Followup Reminder WhatsApp" },

    //APPOINTMENT_SMS
    // {"value": "appointment_sms", "label": "Appointment SMS"},
    //WhatsApp
    // {"value": "e_bill_sms_new", "label": "E Bill Sms New"},
  ];

  const errorMessage = (msg) => {
    setIsErrorMsgText(msg);
    setIsErrorMsg(true);
  };

  const msgClose = () => {
    setIsErrorMsg(false);
    setIsErrorMsgText("");
  };

 const getMessageReport = (isClear = false) => {
  try {
    setLoading(true);
    let statusValue = "";
    if (status === "sent") {
      statusValue = "1";
    } else if (status === "failed") {
      statusValue = "0";
    }
    const messageTypeValue = messageType === "all" ? "" : messageType;
    const smsTypeValue = smsType === "all" ? "" : smsType;
    const params = new URLSearchParams({
      from_date: fromDate,
      to_date: toDate,
      patient_name: patientName?.trim() || "",
      uhid: uhid?.trim() || "",
      mobile: mobile?.trim() || "",
    });

    if (!isClear) {
      if (messageTypeValue) params.append("message_type", messageTypeValue)
      if (smsTypeValue) params.append("sms_type", smsTypeValue)
      if (statusValue) params.append("status", statusValue)
    }

    RestAPIService.getAll(`${Serviceurls.SMS_MESSAGE_REPORT}?${params}`)
      .then((response) => {
        if (response.data.status === "success") {
          const dataWithSno = response.data.data.map((item, index) => ({
            ...item,
            sno: index + 1,
          }));
          setReportData(dataWithSno);
          setTotalMessages(
            response.data.total_count || response.data.data?.length || 0
          );
          setFilteredFromDate(fromDate);
          setFilteredToDate(toDate);
          setLoading(false)
        } else {
          errorMessage(response.data.message);
          setLoading(false)
        }
      })
      .catch((error) => {
        errorMessage(error.response?.data?.message || error.message);
         setLoading(false)
      })
  } catch (e) {
    setLoading(false);
    errorMessage(e.message);
  }
};

  useEffect(() => {
    getMessageReport();
  }, []);

  const handleSelectedDates = (from, to, index) => {
    if (DateTime.fromISO(to) < DateTime.fromISO(from)) {
      errorMessage("End date cannot be before start date");
      return;
    }
    setFromDate(from);
    setToDate(to);
    setDateIndex(index);
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    if (name === "patientName") {
      const filteredValue = value.replace(/[^A-Za-z\s]/g, '');
      setPatientName(filteredValue);
    }
    if (name === "uhid") {
      const filteredValue = value.replace(/[^A-Za-z0-9]/g, '');
      setUhid(filteredValue);
    }
    if (name === "mobile") {
      const filteredValue = value.replace(/[^0-9]/g, '');
      setMobile(filteredValue);
    }
  };

  const onFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === "messageType") setMessageType(value);
    if (name === "smsType") setSmsType(value);
    if (name === "status") setStatus(value);
  };

  const clearFilters = () => {
    setFromDate(DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd"));
    setToDate(DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd"));
    setDateIndex(1);
    setPatientName("");
    setUhid("");
    setMobile("");
    setMessageType("all");
    setSmsType("all");
    setStatus("all")
    getMessageReport(true);
    setFilterOpen(false);

  };

  const applyFilters = () => {
    getMessageReport();
    setFilterOpen(false);
  };

  const closeFilter = () => {
    setFilterOpen(false);
  };

  const renderFilterScreen = () => {
    return (
      <Box className="eMed_rts_filter_container">
        <Box className="eMed_filter_Top">
          <Typography variant="h6" fontWeight={600}>
            {t("Filter")}
          </Typography>
          <Button onClick={closeFilter} className="eMed_usrconf_btn">
            <img
              src={ImagePaths.LabCloseButton.default}
              alt="close"
              className="eMed_action_img_small"
            />
          </Button>
        </Box>
        <Box className="eMed_rts_middle">
          <Box className="eMed_date_filter">
            <CommonDatePicker
              FromDate={fromDate}
              ToDate={toDate}
              DateIndex={dateIndex}
              SelectedDates={handleSelectedDates}
              LabelText={t("Select Date")}
              HideAllMenu={false}
            />
          </Box>
          <TextField
            name="patientName"
            inputProps={{
              maxLength: 20, emed_tid: 'patient_name',
              pattern: "[A-Za-z\\s]*",
              onInput: (e) => {
                e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
              }
            }}
            label="Patient Name"
            value={patientName}
            onChange={handleSearchChange}
            size="small"
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            name="uhid"
            label="UHID"
            value={uhid}
            inputProps={{
              maxLength: 20, emed_tid: 'UHID',
              pattern: "[A-Za-z0-9]*",
              onInput: (e) => {
                e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
              }
            }}
            onChange={handleSearchChange}
            size="small"
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            name="mobile"
            label="Mobile"
            value={mobile}
            onChange={handleSearchChange}
            inputProps={{
              maxLength: 10,
              pattern: "[0-9]*",
              onInput: (e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }
            }}
            size="small"
            fullWidth
            sx={{ mt: 2 }}
          />
          <FormControl size="small" fullWidth sx={{ mt: 2 }}>
            <InputLabel>Message Type</InputLabel>
            <Select
              name="messageType"
              value={messageType}
              onChange={onFilterChange}
              label="Message Type"
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="sms">SMS</MenuItem>
              <MenuItem value="whatsapp">WhatsApp</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Type</InputLabel>
            <Select
              name="smsType"
              value={smsType}
              onChange={onFilterChange}
              label="Select Type"
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              {smsTypes.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth sx={{ mt: 2 }}>
            <InputLabel>Status</InputLabel>
            <Select
              name="status"
              value={status}
              onChange={onFilterChange}
              label="Status"
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="sent">Sent</MenuItem>
              <MenuItem value="failed">Failed</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Stack
          spacing={2}
          direction="row"
          className="eMed_rts_btn"
          alignItems="center"
          justifyContent="center"
        >
          <Button variant="outlined" size="small" onClick={clearFilters}>
            {t("Clear")}
          </Button>
          <Button variant="contained" size="small" onClick={applyFilters}>
            {t("Search")}
          </Button>
        </Stack>
      </Box>
    );
  };

  const gridToolBar = () => {
    const TextArray = [
      {
        label: "From Date",
        value: FilteredFromDate
          ? DateTime.fromISO(FilteredFromDate).toFormat("dd-MM-yyyy")
          : "",
      },
      {
        label: "To Date",
        value: FilteredToDate
          ? DateTime.fromISO(FilteredToDate).toFormat("dd-MM-yyyy")
          : "",
      },
    ];
    return (
      <CommonGridToolBarWithFilterText
        FilterTextArray={TextArray}
      />
    );
  };

  const exportToPDF = () => {
    const params = new URLSearchParams({
      from_date: fromDate,
      to_date: toDate,
      patient_name: patientName || "",
      uhid: uhid || "",
      mobile: mobile || "",
      message_type: messageType === "all" ? "" : messageType,
      sms_type: smsType === "all" ? "" : smsType,
      status: status === "all" ? "" : status,
      export_type: "pdf",
    });
    RestAPIService.getAll(`${Serviceurls.SMS_MESSAGE_REPORT}?${params}`)
      .then((response) => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      })
      .catch((error) =>
        errorMessage(error.response?.data?.message)
      );
  };

  const columns = [
  { field: "sno", headerName: t("S.No"), sortable: false, flex: 0.1 },
  {
    field: "patient_name",
    headerName: t("Patient Details"),
    sortable: true,
    flex: 0.3,
    renderCell: ({ row }) => (
      <CommonPatientDetails data={row} disablePhoto={true} />
    ),
    valueGetter: (params) => {
      const name = params.row?.patient_name || "";
      const uhid = params.row?.uhid || "";
      const mobile = params.row?.phone_number || "";
      return `${name} ${mobile}`;
    }
  },
  {
    field: "date_time",
    headerName: t("Date & Time"),
    sortable: true,
    flex: 0.2,
    valueGetter: (params) => {
      if (!params.row?.date_time) return "-";
      let dateTime;
      if (params.row.date_time.includes("/")) {
        dateTime = DateTime.fromFormat(params.row.date_time, "dd/MM/yyyy HH:mm:ss");
      } else {
        dateTime = DateTime.fromISO(params.row.date_time);
      }
      return dateTime.isValid
        ? dateTime.toFormat("dd-MM-yyyy hh:mm a")
        : params.row.date_time;
    },
  },
  {
    field: "message_type",
    headerName: t("Message Type"),
    sortable: false,
    flex: 0.15,
    valueGetter: (params) =>
      params.row?.message_type
        ? params.row.message_type.toUpperCase()
        : "-",
    renderCell: (params) => (
      <div>{params.row?.message_type?.toUpperCase() || "-"}</div>
    ),
  },
  {
    field: "sms_type",
    headerName: t("Type of SMS"),
    sortable: false,
    flex: 0.55,
    valueGetter: (params) =>
      params.row?.message_category_label || "-",
    renderCell: (params) => (
      <div>{ContentInTooltip(params.row?.message_category_label || "-", 45)}</div>
    ),
  },
  {
    field: "status",
    headerName: t("Status"),
    sortable: false,
    flex: 0.2,
    valueGetter: (params) =>
      params.row?.is_sended === true
        ? "Sent"
        : params.row?.is_sended === false
        ? "Failed"
        : "-",
    renderCell: (params) => (
      <div>
        {params.row?.is_sended === true
          ? "Sent"
          : params.row?.is_sended === false
          ? "Failed"
          : "-"}
      </div>
    ),
  },
];


  return (
    <div className="eMed_rts_container reports_container">
      <Box component={"div"} className='eMed_Top_Container'>
        <Box component={"div"} className='eMed_Cards_Container'>
          {AmountsCard(t("Total Messages"), totalMessages.toString(), true)}
        </Box>
        <Box component={"div"} className='eMed_Action_Container'>
          <Box component={"div"} className='eMed_Filter_Icon_div'>
            <Button className='eMed_usrconf_btn' sx={{ ml: "1vw" }} emed_tid={"eMed_action_img_TestID"} onClick={() => { setFilterOpen(true) }}>
              <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
            </Button>
          </Box>
          <Tooltip title={t("Print")} placement='top' arrow>
            <Button className='eMed_usrconf_btn' emed_tid={"eMed_usrconf_btn_TestID01"} onClick={exportToPDF}>
              <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
            </Button>
          </Tooltip>
        </Box>
      </Box>
      <div className="eMed_rts_table reports_table_card">
        <DataGrid
          rows={reportData}
          columns={columns}
          getRowId={(row) => row.sno}
          page={page}
          onPageChange={setPage}
          pageSize={pageSize}
          onPageSizeChange={setPageSize}
          rowsPerPageOptions={[10, 20, 50]}
          pagination
          sortingMode="client"
          disableSelectionOnClick
          loading={loading}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {t("No Data found")}
              </Stack>
            ),
          }}
          headerHeight={40}
        />
      </div>
      <Drawer
        anchor="right"
        open={FilterOpen}
        ModalProps={{ onBackdropClick: closeFilter }}
      >
        {renderFilterScreen()}
      </Drawer>
      {isErrorMsg && (
        <ToastMsg severity="error" msg={isErrorMsgText} msgPop={msgClose} />
      )}
    </div>
  );
};

export default withTranslation()(MessageReport);


